import { render } from "./DigiQButton.vue?vue&type=template&id=55818158"
import script from "./DigiQButton.vue?vue&type=script&lang=js"
export * from "./DigiQButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__